/**
 * free-gift.js — WiseQ Gratis E-book cadeau
 *
 * Voegt automatisch 1 gratis e-book toe wanneer klant een product
 * toevoegt uit: kinderkoptelefoons, kindertablets, smartwatch-voor-kinderen, gehoorbescherming.
 * Altijd max. 1 e-book per wagen. Werkt via native Shopify Cart API.
 */
(function () {

  var EBOOK_HANDLE = 'e-book';
  var QUALIFYING_COLLECTIONS = [
    'kinderkoptelefoons',
    'kindertablets',
    'smartwatch-voor-kinderen',
    'gehoorbescherming',
  ];
  var FREE_GIFT_PROP = '_free_gift';

  // Slaat de originele fetch op VOORDAT andere scripts hem kunnen overschrijven
  var origFetch = window.fetch.bind(window);

  var isBusy = false;
  var pendingSync = false;
  var ebookVariantId = null;
  var qualifyingProductIds = null; // null = nog niet geladen

  console.log('[FreeGift] script geladen ✓');

  // ─── Hulpfuncties ─────────────────────────────────────────────────────────────

  function fetchCollectionProductIds(handle) {
    return origFetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var ids = (data && data.products || []).map(function (p) { return p.id; });
        console.log('[FreeGift] collectie ' + handle + ': ' + ids.length + ' producten');
        return ids;
      })
      .catch(function (e) {
        console.warn('[FreeGift] kon collectie niet laden: ' + handle, e);
        return [];
      });
  }

  function ensureQualifyingProductIds() {
    if (qualifyingProductIds !== null) return Promise.resolve(qualifyingProductIds);
    return Promise.all(QUALIFYING_COLLECTIONS.map(fetchCollectionProductIds))
      .then(function (arrays) {
        qualifyingProductIds = {};
        arrays.forEach(function (ids) {
          ids.forEach(function (id) { qualifyingProductIds[id] = true; });
        });
        var total = Object.keys(qualifyingProductIds).length;
        console.log('[FreeGift] ' + total + ' kwalificerende producten gecached');
        return qualifyingProductIds;
      });
  }

  function fetchCart() {
    return origFetch('/cart.js').then(function (r) { return r.json(); });
  }

  function fetchEbookVariantId() {
    if (ebookVariantId) return Promise.resolve(ebookVariantId);
    return origFetch('/products/' + EBOOK_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) {
          throw new Error('E-book product niet gevonden: ' + EBOOK_HANDLE);
        }
        ebookVariantId = product.variants[0].id;
        console.log('[FreeGift] e-book variant ID: ' + ebookVariantId);
        return ebookVariantId;
      });
  }

  function addEbook(variantId) {
    var body = { id: variantId, quantity: 1, properties: {} };
    body.properties[FREE_GIFT_PROP] = 'true';
    return origFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function removeEbookByKey(itemKey) {
    return origFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: itemKey, quantity: 0 }),
    }).then(function (r) { return r.json(); });
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
  }

  // ─── Kern-logica ──────────────────────────────────────────────────────────────

  function syncFreeGift() {
    if (isBusy) { pendingSync = true; return; }
    isBusy = true;
    pendingSync = false;
    console.log('[FreeGift] sync gestart...');

    Promise.all([fetchEbookVariantId(), ensureQualifyingProductIds()])
      .then(function (results) {
        var variantId  = results[0];
        var productIds = results[1];

        return fetchCart().then(function (cart) {
          var items = cart.items || [];
          console.log('[FreeGift] cart items:', items.map(function(i){ return i.product_id + ' (' + i.title + ')'; }));

          var hasQualifying = items.some(function (item) {
            var matches = item.variant_id !== variantId && !!productIds[item.product_id];
            if (matches) console.log('[FreeGift] kwalificerend product gevonden: ' + item.title);
            return matches;
          });

          var freeGiftItem = null;
          items.forEach(function (item) {
            if (item.variant_id === variantId && item.properties && item.properties[FREE_GIFT_PROP] === 'true') {
              freeGiftItem = item;
            }
          });

          console.log('[FreeGift] hasQualifying=' + hasQualifying + ' freeGiftInCart=' + !!freeGiftItem);

          if (hasQualifying && !freeGiftItem) {
            console.log('[FreeGift] e-book toevoegen...');
            return addEbook(variantId).then(function () {
              console.log('[FreeGift] e-book toegevoegd ✓');
              refreshCartUI();
            });
          } else if (!hasQualifying && freeGiftItem) {
            console.log('[FreeGift] e-book verwijderen...');
            return removeEbookByKey(freeGiftItem.key).then(function () {
              console.log('[FreeGift] e-book verwijderd ✓');
              refreshCartUI();
            });
          } else {
            console.log('[FreeGift] niets te doen');
          }
        });
      })
      .catch(function (err) { console.warn('[FreeGift] fout:', err); })
      .then(function () {
        isBusy = false;
        if (pendingSync) syncFreeGift();
      });
  }

  // ─── Trigger 1: Shopify pubsub (het meest betrouwbaar voor dit theme) ─────────
  function initPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(initPubSub, 100);
      return;
    }
    console.log('[FreeGift] pubsub listener actief ✓');
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'free-gift') return;
      console.log('[FreeGift] cart update via pubsub:', event && event.source);
      syncFreeGift();
    });
    // Controleer ook bij laden van de pagina
    syncFreeGift();
  }

  // ─── Trigger 2: fetch interceptor (vangt ook externe app-aanroepen op) ────────
  window.fetch = function (input, init) {
    var url = (input instanceof Request ? input.url : String(input || ''));
    var isMutation = /\/(cart\/(add|change|update|clear))(\.js)?(\?|$)/.test(url);
    var promise = origFetch(input, init);
    if (isMutation) {
      console.log('[FreeGift] cart mutatie gedetecteerd via fetch: ' + url);
      promise.then(function (response) {
        if (response && response.ok) setTimeout(syncFreeGift, 150);
        return response;
      });
    }
    return promise;
  };

  // ─── Start ────────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPubSub);
  } else {
    initPubSub();
  }

})();
